"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentNotFound = exports.RenderHost = exports.SYMBOL_LC_NAME = exports.SYMBOL_LC = void 0;
/* eslint-disable prefer-rest-params */
var react_1 = require("react");
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var jsExpression_1 = require("../utils/jsExpression");
var schema_1 = require("../designer/core/schema");
var fiber_1 = require("./fiber");
Object.defineProperty(exports, "SYMBOL_LC", { enumerable: true, get: function () { return fiber_1.SYMBOL_LC; } });
Object.defineProperty(exports, "SYMBOL_LC_NAME", { enumerable: true, get: function () { return fiber_1.SYMBOL_LC_NAME; } });
var event_1 = require("../utils/event");
var supportsES6 = (function () {
    try {
        // eslint-disable-next-line no-new-func
        new Function('(a = 0) => a?.b');
        return true;
    }
    catch (err) {
        return false;
    }
})();
var lifeCycles = ['componentDidUpdate', 'componentDidMount', 'componentWillUnmount'];
var interceptComponent = function (comp, callback) {
    lifeCycles.forEach(function (lifeCycle) {
        var origin = comp.prototype[lifeCycle];
        // eslint-disable-next-line
        comp.prototype[lifeCycle] = function () {
            origin === null || origin === void 0 ? void 0 : origin.call.apply(origin, __spreadArray([this], __read(arguments), false));
            try {
                callback.apply(void 0, __spreadArray([lifeCycle, this.props, this.state], __read(arguments), false));
            }
            catch (e) {
                console.error('interceptComponentLifeCycleWrong', lifeCycle);
            }
        };
    });
};
var detectComponentType = function (comp) {
    var _b;
    if (!comp)
        return 'null';
    if (typeof comp.render === 'function')
        return 'exotic';
    if (typeof ((_b = comp.prototype) === null || _b === void 0 ? void 0 : _b.render) === 'function')
        return 'class';
    return 'fc';
};
var RenderHost = /** @class */ (function () {
    function RenderHost() {
        var _this = this;
        this.components = {};
        /** 从传入的 dom 开始往上查找其RenderHost代理节点 */
        this.findFiberInstance = fiber_1.findFiberInstance;
        /** 根据 fiber(class) 获取其dom */
        this.findElement = fiber_1.findElement;
        /** 根据 attr 属性向上查找满足条件的dom节点 */
        this.findElementByAttr = fiber_1.findElementByAttr;
        /** 判断 prop 值是否是表达式 */
        this.isJSExpression = jsExpression_1.isJSExpression;
        /** root节点生命周期 */
        this.pageLifeCycle = new event_1.ReadableEvent();
        /** all lowcode instance */
        this.instances = new Map();
        /** 缓存同名组件包裹类型 */
        this.componentsTypeMap = new Map();
        /** 记录组件类型 */
        this.componentsType = new Map();
        /** register component for render */
        this.injectComponent = function (comps) {
            Object.keys(comps).forEach(function (name) {
                var comp = comps[name];
                if (name === schema_1.ROOT_NAME) {
                    var prototype = comp.prototype;
                    if (typeof prototype.render !== 'function') {
                        throw new Error("".concat(name, " Component MUST be ComponentClass"));
                    }
                    interceptComponent(comp, function (lifeCycle) {
                        var params = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            params[_i - 1] = arguments[_i];
                        }
                        _this.pageLifeCycle.emit(lifeCycle, params);
                    });
                }
                _this.componentsType.set(name, detectComponentType(comp));
                _this.components[name] = comp;
            });
        };
        this.getComp = function (componentName) {
            var comp = _this.components[componentName];
            if (!comp)
                return ComponentNotFound;
            var cacheComp = _this.componentsTypeMap.get(componentName);
            if (cacheComp) {
                return cacheComp;
            }
            return _this.createLCWrapComp(componentName);
        };
        this.createLCWrapComp = function (componentName) {
            var _b;
            // eslint-disable-next-line
            var renderHost = _this;
            var comp = _this.components[componentName];
            var wrapped = (_b = /** @class */ (function (_super) {
                    __extends(class_1, _super);
                    function class_1(props) {
                        var _this = _super.call(this, props) || this;
                        /** 部分属性半受控,用于可视化编辑态下实现局部更新 */
                        _this.state = { localProps: undefined, error: '' };
                        /** real ref for node. available for class/forward, undefined for FC */
                        _this.nodeRef = (0, react_1.createRef)();
                        /** root (state) dependencies. collect on render */
                        _this.deps = [];
                        _this.resetState = function (_b) {
                            var _c = _b === void 0 ? { opt: '' } : _b, opt = _c.opt;
                            if (opt === 'remove' || !_this.state.localProps)
                                return;
                            _this.setState({ localProps: undefined, error: '' });
                        };
                        _this.updateLocalProp = function (_b) {
                            var _c = __read(_b, 3), newProps = _c[2];
                            _this.setState(__assign(__assign({}, _this.state), { localProps: newProps }));
                        };
                        _this[fiber_1.SYMBOL_LC] = _this.props._LC_ID;
                        _this[fiber_1.SYMBOL_LC_NAME] = componentName;
                        renderHost.instances.set(props._LC_ID, _this);
                        return _this;
                    }
                    class_1.prototype.componentDidCatch = function (error) {
                        var errMsg = JSON.stringify({ msg: error.message, stack: error.stack });
                        this.setState({ error: errMsg });
                    };
                    class_1.prototype.componentDidMount = function () {
                        var _b, _c;
                        var id = this.props._LC_ID;
                        (_b = window.engine) === null || _b === void 0 ? void 0 : _b.schema.on("node.update.".concat(id), this.updateLocalProp);
                        (_c = window.engine) === null || _c === void 0 ? void 0 : _c.schema.on('update', this.resetState);
                    };
                    class_1.prototype.componentDidUpdate = function (prevProps) {
                        if ((0, isEqual_1.default)(prevProps, this.props))
                            return;
                        // props changed, then clear local cache & use the new one
                        this.setState({ localProps: undefined, error: '' });
                    };
                    class_1.prototype.componentWillUnmount = function () {
                        var _b, _c;
                        var id = this.props._LC_ID;
                        renderHost.instances.delete(id);
                        (_b = window.engine) === null || _b === void 0 ? void 0 : _b.schema.removeListener("node.update.".concat(id), this.updateLocalProp);
                        (_c = window.engine) === null || _c === void 0 ? void 0 : _c.schema.removeListener('update', this.resetState);
                    };
                    class_1.prototype.shouldComponentUpdate = function (nextProps, nextState) {
                        return nextProps !== this.props || nextState !== this.state;
                    };
                    class_1.prototype.computeProps = function () {
                        var _this = this;
                        // eslint-disable-next-line
                        var _b = this.props, _LC_ID = _b._LC_ID, children = _b.children, nodeAlias = _b.nodeAlias, _other = _b._other, othersProps = __rest(_b, ["_LC_ID", "children", "nodeAlias", "_other"]);
                        var localProps = this.state.localProps;
                        var props = localProps || othersProps;
                        var isChanged = false;
                        this.deps = [];
                        var transformProps = (0, jsExpression_1.visitPropsExpression)(props, function (code, _obj, _key, entity) {
                            var codeStr = supportsES6 ? code : (entity.code || code);
                            var _b = renderHost.parseExpression(codeStr, _this.nodeRef.current), ret = _b.ret, deps = _b.deps;
                            if (deps.length) {
                                _this.deps.push(deps.pop());
                                isChanged = true;
                            }
                            return ret;
                        });
                        if (isChanged) {
                            props = transformProps;
                        }
                        return __assign(__assign({}, props), { componentName: componentName, key: _LC_ID, _LC_ID: _LC_ID, ref: renderHost.componentsType.get(componentName) !== 'fc' ? this.nodeRef : undefined });
                    };
                    class_1.prototype.render = function () {
                        var error = this.state.error;
                        if (error) {
                            return (0, react_1.createElement)('div', { className: 'component-render-error', style: { padding: 20 } }, "ComponentRenderError: [".concat(componentName, "] - ").concat(error));
                        }
                        var children = this.props.children;
                        var props = this.computeProps();
                        return (0, react_1.createElement)(comp, props, children);
                    };
                    return class_1;
                }(react_1.Component)),
                _b.displayName = "".concat(componentName, "Wrap"),
                _b.componentName = componentName,
                _b);
            _this.componentsTypeMap.set(componentName, wrapped);
            return wrapped;
        };
        /** 滚动到节点 */
        this.scrollToComp = function (/** 实例id */ id, animation) {
            if (animation === void 0) { animation = true; }
            var el = (0, fiber_1.findElement)(_this.instances.get(id));
            if (!el)
                return;
            el === null || el === void 0 ? void 0 : el.scrollIntoView(animation ? { behavior: 'smooth', block: 'start', inline: 'start' } : undefined);
        };
        /** 获取所有给定组件名称的代理节点实例 */
        this.findInstancesByName = function (/** 组件名 */ name) {
            var res = [];
            var it = _this.instances.values();
            var next = it.next();
            while (!next.done) {
                if (next.value.constructor.componentName === name) {
                    var ref = next.value;
                    res.push({
                        ref: ref,
                        el: (0, fiber_1.findElement)(ref),
                    });
                }
                next = it.next();
            }
            return res;
        };
        /** 根据ID查找节点实例 */
        this.findInstanceById = function (id) { var _b; return (_b = _this.instances.get(id)) === null || _b === void 0 ? void 0 : _b.nodeRef.current; };
        /** 获取页面根节点 */
        this.getPageNode = function () { return _this.findInstanceById(schema_1.ROOT_ID); };
        /** 根据ID查找代理节点实例 */
        this.findProxyInstanceById = function (id) { return _this.instances.get(id); };
        /** 根据nodeID获取其dom element */
        this.getDOMById = function (nodeId) { return (0, fiber_1.findElement)(_this.findProxyInstanceById(nodeId)); };
        /** 设置 Page Node state */
        this.setState = function (newState) {
            var _b;
            var pageInstance = _this.instances.get(schema_1.ROOT_ID);
            var fiber = ((_b = pageInstance._reactInternalFiber) === null || _b === void 0 ? void 0 : _b.child.stateNode) || pageInstance._reactInternals.child.stateNode;
            fiber === null || fiber === void 0 ? void 0 : fiber.setState(newState);
        };
        // eslint-disable-next-line @typescript-eslint/member-ordering
        this.parseExpression = (function () {
            var attrDependencies = [];
            var proxyObj = function (obj, deps) {
                if (deps === void 0) { deps = []; }
                return new Proxy(obj, {
                    get: function (target, key, receiver) {
                        var val = Reflect.get(target, key, receiver);
                        if (typeof key === 'symbol')
                            return val;
                        attrDependencies.push(__spreadArray(__spreadArray([], __read(deps), false), [String(key)], false).join('.'));
                        return val;
                        // 暂时不监听多层
                        // if (isBasicType(val)) return val;
                        // return proxyObj(val, [...deps, String(key)]);
                    },
                });
            };
            var proxyRoot;
            return function (code, instance) {
                attrDependencies = [];
                if (!proxyRoot)
                    proxyRoot = proxyObj(_this.findInstanceById(schema_1.ROOT_ID));
                var withSelfCode = "with(root){return eval(`".concat(code.replace(/this(\W|$)/g, function (_a, b) { return "root".concat(b); }), "`);}");
                var parse = function (root) {
                    try {
                        // eslint-disable-next-line no-new-func
                        var val = new Function('root', 'self', withSelfCode)(root, instance);
                        return val;
                    }
                    catch (e) {
                        console.error("JSExpression execute failed: ".concat(e.message));
                        return code;
                    }
                };
                return { ret: parse(proxyRoot), deps: attrDependencies };
            };
        })();
        this.pageLifeCycle.on('componentDidUpdate', function (params) {
            if (params[1] === params[3])
                return;
            Array.from(_this.instances.values()).forEach(function (inst) {
                if (!inst.deps.find(function (dep) { return dep.indexOf('state') === 0; }))
                    return;
                inst.forceUpdate();
            });
        });
    }
    return RenderHost;
}());
exports.RenderHost = RenderHost;
exports.default = new RenderHost();
var ComponentNotFound = /** @class */ (function (_super) {
    __extends(ComponentNotFound, _super);
    function ComponentNotFound(props) {
        var _this = _super.call(this, props) || this;
        _this[fiber_1.SYMBOL_LC] = _this.props._LC_ID;
        return _this;
    }
    ComponentNotFound.prototype.render = function () {
        var _b = this.props, children = _b.children, others = __rest(_b, ["children"]);
        return (0, react_1.createElement)('div', {}, children || "Component Not Found ".concat(this.props.componentName, ": ").concat(JSON.stringify(others)));
    };
    return ComponentNotFound;
}(react_1.PureComponent));
exports.ComponentNotFound = ComponentNotFound;
